import Meta from "@/components/templates/Meta";
import { Header } from "@/components/templates/Header";
import { Footer } from "@/components/templates/Footer";
import Layout from "@/components/templates/Layout";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import { useBudouX } from "@/hooks/useBudouX";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import Pager from "@/components/organisms/Pagination";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// パス一覧取得（microCMS + TWP統合）
export async function getStaticPaths() {
  const { fetchAllNewsIds } = await import("@/lib/news-api");

  // 両方のソースから詳細ページありのニュースIDを取得
  const allNewsIds = await fetchAllNewsIds();

  const paths = allNewsIds.map((item) => ({
    params: { newsId: item.id },
  }));

  return {
    // fallback: 'blocking' でビルド後に追加されたコンテンツもISRで対応
    fallback: 'blocking',
    paths: paths,
  };
}

// 個別ニュース取得（microCMS + TWP統合）
export async function getStaticProps(context) {
  const { fetchNewsById } = await import("@/lib/news-api");

  const newsId = context.params.newsId;

  // IDに基づいて適切なソースから取得
  const news = await fetchNewsById(newsId);

  // 記事が見つからない場合は404
  if (!news) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      news: news,
    },
    // ISR: 60秒ごとに再生成
    revalidate: 60,
  };
}

export default function NewsArticle(props) {
  const news = props.news;
  const isHeaderRelative = true;
  const { parse } = useBudouX();
  return (
    <>
      <Meta
        pageTitle={news.title}
        pageDescription={
          "株式会社トッカシステムズからのお知らせです。" +
          news.title +
          "日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/news/article/" + news.id}
        noIndex={news.noindexflg}
      />
      <Layout className="bg-gray-50">
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="pt-6 pb-12 md:pt-8 md:pb-20">
              <BreadCrumb
                lists={[
                  {
                    name: "TOP",
                    path: "/",
                  },
                  {
                    name: "News",
                    path: "/news/",
                  },
                  {
                    name: news.title,
                  },
                ]}
              />
              <div className="bg-white py-6 md:mt-6 md:py-10 lg:py-20">
                <div
                  className="
                    mx-auto
                    mb-8
                    max-w-4xl
                    space-y-6
                    border-x-0
                    border-t-0
                    border-b
                    border-solid
                    border-bdc-light
                    px-8
                    pb-6
                    md:space-y-8
                    lg:px-0
                  "
                >
                  <p className="text-sm font-bold text-txt-light">
                    {" "}
                    {dayjs.utc(news.date).tz("Asia/Tokyo").format("YYYY.MM.DD")}
                  </p>
                  <h3 className="text-2xl font-bold text-txt-base">
                    {news.title}
                  </h3>
                </div>
                <div
                  className="mx-auto max-w-4xl px-8 text-md text-txt-base lg:px-0"
                  dangerouslySetInnerHTML={{
                    __html: news.content,
                  }}
                ></div>
              </div>
              <Pager Top />
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
